<template>
    <div>
        <a-modal
            :class="'modal epic-' + moduleStateLink"
            :title="$t('company.upload_history_covers.title')"
            :destroyOnClose="true"
            v-model:open="modal_visible"
            :footer="null"
            width="auto"
            :dialog-style="{ padding: '0 20px', maxWidth: '1536px' }"
        >
            <div class="form-container">
                <upload-log-table :company_id="company_id" @onTableAction="onTableAction" />
            </div>
        </a-modal>
        <a-drawer
            data-cy="upload-drawer"
            :title="$t('company.upload_history.drawer.title')"
            :width="500"
            :open="drawer_visible"
            :body-style="{ padding: '0px', paddingBottom: '10px' }"
            :destroyOnClose="true"
            :maskClosable="false"
            :rootClassName="'epic-' + moduleStateLink"
            @close="onClose"
        >
            <view-upload-log :upload_log="upload_log" @onDrawerClose="onClose" />
        </a-drawer>
    </div>
</template>

<script>
import UploadLogTable from '@/components/tables/UploadLogsCovers.vue';
import ViewUploadLog from '@/components/views/UploadLogCover.vue';

export default {
    components: {
        UploadLogTable,
        ViewUploadLog,
    },
    data() {
        return {
            modal_visible: false,
            drawer_visible: false,
            upload_log: {},
        };
    },
    computed: {
        moduleStateLink() {
            return this.$store.state.system.is_epicvault_enabled ? 'default' : 'claim';
        },
    },
    props: {
        company_id: {
            type: String,
            default: '',
        },
    },
    methods: {
        onTableAction(data) {
            switch (data.key) {
                case 'open':
                    this.$http.get('/api/cover-import-audit-logs/' + data.id).then((response) => {
                        this.upload_log = {
                            ...response.data.data,
                            created_at: this.$dayjs(response.data.data.created_at).format('YYYY-MM-DD'),
                        };
                    });

                    this.drawer_visible = true;
                    break;
            }
        },
        onClose() {
            this.drawer_visible = false;
        },
        showModal() {
            this.modal_visible = true;
        },
    },
};
</script>
